import { render, staticRenderFns } from "./SetPhoto.vue?vue&type=template&id=04ebf05d&scoped=true&"
import script from "./SetPhoto.vue?vue&type=script&lang=js&"
export * from "./SetPhoto.vue?vue&type=script&lang=js&"
import style0 from "./SetPhoto.vue?vue&type=style&index=0&id=04ebf05d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ebf05d",
  null
  
)

export default component.exports